/**
 * @generated SignedSource<<1771290e11ea6f602599c70a1393c4b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateCardFullsizeNoteTemplate$data = {
  readonly appliedCount: number;
  readonly author: {
    readonly " $fragmentSpreads": FragmentRefs<"TemplateAuthor_Author">;
  } | null;
  readonly starred: boolean;
  readonly summary: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"StarButtonNoteTemplate">;
  readonly " $fragmentType": "TemplateCardFullsizeNoteTemplate";
};
export type TemplateCardFullsizeNoteTemplate$key = {
  readonly " $data"?: TemplateCardFullsizeNoteTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"TemplateCardFullsizeNoteTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TemplateCardFullsizeNoteTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "starred",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appliedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TemplateAuthor_Author"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StarButtonNoteTemplate"
    }
  ],
  "type": "NoteTemplateNode",
  "abstractKey": null
};

(node as any).hash = "aa2270bc5648516886f08eb8281d99a5";

export default node;
